const INTRO_LAST_SHOWN_KEY = 'elka-intro-last-shown';

export function shouldShowIntroToday(): boolean {
  const lastShown = localStorage.getItem(INTRO_LAST_SHOWN_KEY);
  if (!lastShown) return true;
  const today = new Date();
  const todayStr = today.toISOString().split('T')[0];
  return lastShown !== todayStr;
}

export function markIntroShown(): void {
  const today = new Date();
  const todayStr = today.toISOString().split('T')[0];
  localStorage.setItem(INTRO_LAST_SHOWN_KEY, todayStr);
}
